export default "__VITE_ASSET__BtYwkP6i__"